/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const BookmarkStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M9.37145 2C7.23212 2 5.5 3.69296 5.5 5.78146V22L11.9517 15.1715C11.9642 15.1583 11.9817 15.1508 12 15.1508C12.0183 15.1508 12.0358 15.1583 12.0483 15.1715L18.5 22V5.78158C18.5 3.69308 16.7658 2.00001 14.6263 2.00001L9.37145 2Z"
          fillRule="evenodd"
          clipRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { BookmarkStrokeIcon };
